const let_10 = [
    "correcting",
    "jardiniere",
    "caramelize",
    "blackberry",
    "cantaloupe",
    "strawberry",
    "watermelon",
    "nutcracker",
    "dishwasher",
    "tablecloth",
    "dinnertime",
    "dinnerware",
    "restaurant",
    "vegetarian" ,
    "toothbrush",
    "strawberry",
    "nourishing",
    "rotisserie",
    "discerning",
    "blackberry",
    "buttermilk",
    "applesauce",
    "mayonnaise",
    "tenderloin",
    "delicately",
    "maisonette",
    "restaurant",
    "generously",
    "wellington",
    "teetotaler",
    "vegetarian",
    "cheesecake",
    "constantly",
    "smokehouse",
    "accountant",
    "gastronome",
    "shortbread",
    "greenhouse",
    "nutritious",
    "unflavored",
    "tablecloth",
    "ingredient",
    "coffeecake",
    "ubiquitous",
    "perishable",
    "sweetening",
    "peppermint",
    "gastronomy",
    "spirituous",
    "caramelize",
    "proprietor",
    "jardiniere",
    "beneficial",
    "patisserie",
    "delectable",
    "applesauce",
    "chartreuse",
    "vermicelli",
    "unbleached",
    "shoestring",
    "decorative",
    "tenderloin",
    "cellophane",
    "commercial",
    "blackening",
    "peppermint",
    "individual",
    "fingerling",
    "gingersnap",
    "gooseberry",
    "smokehouse",
    "cheesecake",
    "strawberry",
    "breadfruit",
    "granulated",
    "shortening",
    "dissolving",
    "substitute",
    "squeezable",
    "butterball",
    "artificial",
    "cantaloupe",
    "blackberry",
    "ladyfinger",
    "grapefruit",
    "cornstarch",
    "unseasoned",
    "liverwurst",
    "disposable",
    "unflavored",
    "cuttlefish",
    "coffeecake",
    "compressed",
    "buttermilk",
    "elderberry",
    "shortbread",
    "sauerkraut",
    "watermelon",
    "nasturtium",
    "supplement",
    "peppercorn",
    "mayonnaise",
    "vegetarian",
    "maraschino",
    "rotisserie",

    
];

export default let_10;
